<template>
    <f7-page no-navbar>
        <f7-list v-if="deviceList.length>0" class='device-list'>
            <!--@click="jumpToDetail(device,index)"-->
            <f7-list-item v-for="(device,index) in deviceList"
                          :swipeout="device.status===0"
                          @swipeout:deleted="handleDelDevice(device,index)"
                          @click="changeDevice(device,index)"
                          :key="index">
                <div slot='after'>
                    <img @click.stop="jumpToDetail(device,index)" src="../../assets/icon_edit.png" class='i-edit'
                         alt="">
                </div>
                <div slot='title'>
                    <img :class="{hide:device.status===0}" src="../../assets/icon_check.png" class='i-check' alt="">
                    {{device.name || '设备'+(device.id)}}
                </div>
                <f7-swipeout-actions right v-if='device.status===0'>
                    <f7-swipeout-button delete confirm-text="确定删除此文件？">
                        删除
                    </f7-swipeout-button>
                </f7-swipeout-actions>
            </f7-list-item>
        </f7-list>
        <base-toolbar slot="fixed"></base-toolbar>
        <div class="fab fab-extended fab-center-bottom">
            <div class='add-device' @click="addDevice">+添加设备</div>
        </div>
    </f7-page>
</template>

<script>
  import {
    f7NavRight, f7Link, f7Navbar, f7List, f7ListItem, f7Badge, f7SwipeoutActions, f7SwipeoutButton, f7Icon, f7Fab
  } from 'framework7-vue'
  import BaseToolbar from 'components/baseToolbar/BaseToolbar'
  import { globalConst as native, modalTitle } from 'lib/const'
  import { mapState } from 'vuex'
  import { bus } from 'src/main'

  export default {
    name: '',
    data () {
      return {}
    },
    created () {
      const {commit} = this.$store
      commit('setActiveTabbarItem', 'device')
      this.loadDeviceList()
    },
    methods: {
      loadDeviceList () {
        this.$store.dispatch({
          type: native.loadDeviceList
        })
      },
      addDevice () {
        let that = this
        if (__DEBUG__) {
          // 1E:88:79:05:3A:86  1E:88:79:05:80:7E 1E:88:79:05:55:90
          let macAddr = '40:d6:3c:1e:70:fe'
          let reg = /(([a-f0-9]{2}:)|([a-f0-9]{2}-)){5}[a-f0-9]{2}/gi
          if (!reg.test(macAddr)) {
            that.$f7.dialog.alert('MAC地址格式不正确，请扫描正确的设备MAC地址...', modalTitle)
            return
          }
          that.$store.dispatch({
            type: native.doBindDevice,
            macAddr
          }).then(() => {
            that.$store.commit('setDownLoaderServerUrl', '')
            that.$store.commit('setMacAddr', macAddr)
            this.loadDeviceList()
            bus.$emit('loadData')
          })
        } else {
          wx.scanQRCode({
            needResult: 1,
            scanType: ['qrCode'],
            success: function (res) {
              var result = res.resultStr
              let reg = /(([a-f0-9]{2}:)|([a-f0-9]{2}-)){5}[a-f0-9]{2}/gi
              if (!reg.test(result)) {
                that.$f7.dialog.alert('MAC地址格式不正确，请扫描正确的设备MAC地址...', modalTitle)
                return
              }
              that.$store.dispatch({
                type: native.doBindDevice,
                macAddr: result
              }).then(() => {
                that.$store.commit('setDownLoaderServerUrl', '')
                that.$store.commit('setMacAddr', result)
                that.loadDeviceList()
                bus.$emit('loadData')
              })
            }
          })
        }
      },
      jumpToDetail (device, index) {
        this.$f7router.navigate(`/device/detail/${index}`)
      },
      handleDelDevice (device, index) {
        this.$store.dispatch({
          type: native.delDevice,
          macAddr: device.macAddr
        }).then(() => {
          this.$f7.dialog.alert('删除成功', modalTitle)
        }).catch(() => {
          this.$f7.dialog.alert('删除失败', modalTitle)
        })
      },
      changeDevice (deviceInfo, index) {
        let {dispatch, commit} = this.$store
        this.$store.state.showLoading_local = true
        this.$store.state.loadingMsg_local = '设备切换中，请稍候...'
        dispatch({
          type: native.changeDevice,
          macAddr: deviceInfo.macAddr
        }).then((data) => {
          this.$f7.dialog.alert('设备切换成功', modalTitle)
          commit('setDownLoaderServerUrl', '')
          commit('setMacAddr', deviceInfo.macAddr)
          bus.$emit('loadData')
          this.$store.state.showLoading_local = false
          this.$store.commit('clearListFile')
          this.deviceList.forEach((device) => {
            device.status = device.id === deviceInfo.id ? 1 : 0
          })
        }).catch(() => {
          this.$f7.dialog.alert('设备切换失败', modalTitle)
          this.$store.state.showLoading_local = false
        })
      }
    },
    computed: {
      ...mapState({
        deviceList: ({device}) => device.deviceList
      })
    },
    components: {
      f7Navbar,
      f7NavRight,
      f7Link,
      BaseToolbar,
      f7List,
      f7ListItem,
      f7Badge,
      f7SwipeoutActions,
      f7SwipeoutButton,
      f7Icon,
      f7Fab
    }
  }
</script>

<style lang="scss" scoped type="text/css">
    @import "../../css/deviceList.scss";
</style>